/**
 * Subscribes every handler of the map to its event on the target
 *
 * @param {EventTarget} target
 * @param {Object<string, Function>} handlers handlers by event name
 * @returns {Function} removes all the subscribed handlers
 */
export const listen = (target, handlers) => {
  const entries = Object.entries(handlers);
  entries.forEach(([event, handler]) => target.addEventListener(event, handler));

  return () => entries.forEach(([event, handler]) => target.removeEventListener(event, handler));
};
